// @flow

import type {PureAction} from '@travel-frontend/state-handling-sdk';

import {PURE} from '@travel-frontend/state-handling-sdk';

export const SET_DATA_TAKEN_AFTER_LOGIN =
  'uiState/profile/SET_DATA_TAKEN_AFTER_LOGIN';
export const SET_PROFILE_DATA_LOADED =
  'uiState/profile/SET_PROFILE_DATA_LOADED';

export const setDataTakenAfterLogin = (value: boolean): PureAction => {
  return {
    type: PURE(SET_DATA_TAKEN_AFTER_LOGIN),
    value,
  };
};

export const setProfileDataLoaded = (value: boolean): PureAction => {
  return {
    type: PURE(SET_PROFILE_DATA_LOADED),
    value,
  };
};
